import { Link } from 'react-router-dom';
import type { WorkItem } from '@/types/content';

export default function WorkCard({ item }: { item: WorkItem }) {
  return (
    <article className="group h-full">
      <Link to={`/detail/works/${item.id}`} className="block cursor-pointer">
        <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden bg-background-200 border border-background-200/80">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 琉璃神社作品介绍`}
            className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/10 to-transparent opacity-80 group-hover:opacity-95 transition-opacity"></div>
          <div className="absolute top-3 left-3 flex items-center gap-1.5">
            <span className="px-2 py-1 rounded bg-background-50/90 text-[11px] leading-none text-primary-800">
              {item.type}
            </span>
            <span className="px-2 py-1 rounded bg-background-50/90 text-[11px] leading-none text-foreground-700">
              {item.region}
            </span>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
            <div className="flex items-end justify-between gap-2">
              <div className="min-w-0">
                <h3 className="text-sm md:text-[15px] font-semibold text-background-50 truncate">
                  {item.title}
                </h3>
                <p className="mt-1 text-[11px] text-background-100/70 font-label">
                  {item.year} · {item.status.slice(0, 8)}
                </p>
              </div>
              <span className="shrink-0 text-xs text-accent-300 font-label">{item.score.toFixed(1)}</span>
            </div>
          </div>
          <div className="absolute inset-x-3 bottom-16 md:bottom-16 flex justify-center">
            <span className="inline-flex items-center gap-1.5 h-8 px-3.5 rounded-full bg-background-50 text-primary-800 text-xs whitespace-nowrap opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
              查看详情
              <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
            </span>
          </div>
        </div>
      </Link>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {item.tags.slice(0, 3).map((tag) => (
          <span
            key={tag}
            className="px-2 py-0.5 rounded bg-secondary-100 text-[11px] text-secondary-700 whitespace-nowrap"
          >
            {tag}
          </span>
        ))}
      </div>
      <p className="mt-2 text-xs text-secondary-600 leading-5 clamp-2">{item.intro}</p>
    </article>
  );
}